export default "__VITE_ASSET__R_ddKpds__"